export default __webpack_public_path__ + "static/media/giggle.38de1619.gif";